import { FORGET_ALL, UI_SETTINGS_CHANGED } from './constants'

export const forgetAllPinnedUsers = () => ({
    type: FORGET_ALL,
})

export const uiSettingsChanged = newUiSettings => ({
    type: UI_SETTINGS_CHANGED,
    payload: newUiSettings,
})



// WEBPACK FOOTER //
// ./src/features/Settings/data/actions.js